<template>
  <App
    title="试驾排程"
    left-arrow
    class="testDrive"
  >
    <div slot="title">
      <span class="storeTitle">{{countDay}}</span>
    </div>
    <div slot="right">
      <Icon
        name="search"
        color="#DA3738"
        size="20"
        class="titleSearch"
        v-auth="'ScheduleManagement-Search'"
        @click="testdriveSearch"
      />
      <Icon
        name="plus"
        size="20"
        color="#DA3738"
        v-auth="'ScheduleManagement-CreateSchedule'"
        @click="createTestdrive"
      />
    </div>
    <div slot="extra">
      <Cell
        is-link
        :title="store.name"
        @click="storeShow = true"
      />
      <div>
        <Popup
          v-model="storeShow"
          round
          position="bottom"
        >
          <RadioGroup v-model="storeCode">
            <CellGroup
              v-for="$i in storeListS"
              :key="$i.code"
            >
              <Cell
                :title="$i.name"
                clickable
                @click="onstoreClick($i)"
              >
                <template #right-icon>
                  <Radio :name="$i.code" />
                </template>
              </Cell>
            </CellGroup>
          </RadioGroup>
        </Popup>
      </div>
    </div>

    <div class="container">
      <Popup
        v-model="swiperDay"
        round
        position="bottom"
      >
        <RadioGroup
          v-model="timeRadio.current"
          @change="onRadioChange"
        >
          <CellGroup
            v-for="$i in timeRadio.list"
            :key="$i.label"
          >
            <Cell
              :title="$i.name"
              clickable
              @click="onRadioClick($i)"
            >
              <template #right-icon>
                <Radio :name="$i.label" />
              </template>
            </Cell>
          </CellGroup>
        </RadioGroup>
      </Popup>
      <template v-if="timeRadio.current === 'day'">
        <CalendarDay
          :schedules="schedules"
          :start="initDay"
        />
      </template>
      <template v-if="timeRadio.current === 'week'">
        <CalendarWeek
          :schedules="schedules"
          :storeCode="store.code"
          :start="initDay"
        />
      </template>
      <template v-if="timeRadio.current === 'month'">
        <CalendarMonth
          :schedules="schedules"
          :storeCode="store.code"
          :start="initDay"
        />
      </template>
    </div>
    <footer slot="footer">
      <Row
        type="flex"
        justify="center"
      >
        <Cols
          span="11"
          class="buttonWrap"
        >
          <Button
            type="default"
            round
            icon="arrow-left"
            @click="prevFn"
          />
          <Button
            type="primary"
            round
            class="today"
            @click="todayFn"
          >{{timeRadio.todayShow}}</Button>
          <Button
            type="default"
            round
            icon="arrow"
            @click="nextFn"
          />
        </Cols>
        <Cols
          span="5"
          class="buttonWrap"
        >
          <Button
            type="default"
            round
            @click="showSwiper"
          >{{timeRadio.currentShow}}
            <Icon
              name="arrow-up"
              class="schedule"
            />
          </Button>
        </Cols>
        <Cols
          span="4"
          class="buttonWrap"
        >
          <Button
            type="default"
            round
            @click="testdriveList"
          >列表</Button>
        </Cols>
      </Row>
    </footer>
  </App>
</template>

<script>
import dayjs from 'dayjs'
import weekday from 'dayjs/plugin/weekday'
dayjs.extend(weekday)
import CalendarDay from './day/index'
import CalendarWeek from './week/index'
import CalendarMonth from './month/index'
import 'vant/lib/nav-bar/style'
import 'vant/lib/list/style'
import 'vant/lib/popup/style'
import 'vant/lib/cell-group/style'
import 'vant/lib/cell/style'
import 'vant/lib/radio-group/style'
import 'vant/lib/radio/style'
import '@/style/vant-patch.less'
import { Row, Col, Button, Icon, Popup, RadioGroup, CellGroup, Cell, Radio, Toast } from 'vant';
import '@/style/common.less';
import './index.less'

import { checkTime } from '@/api/testdrive/index'
export default {
  name: 'testDrive',
  data () {
    return {
      storeShow: false, //选择门店的弹框的显示与否
      swiperDay: false,// 选择周日月的弹框的显示与否
      initDay: '',
      countDay: '',
      storeCode: '',
      schedules: [],
      // schedulesWeek: [],
      // schedulesMonth: [],
      store: {},// 当前门店对象
      storeListS: [],
      timeRadio: {
        current: 'day',
        currentShow: '日',
        todayShow: '今日',
        list: [
          {
            name: '日',
            label: 'day'
          },
          {
            name: '周',
            label: 'week'
          },
          {
            name: '月',
            label: 'month'
          }
        ]
      }
    }
  },
  components: {
    Icon,
    Row,
    Cols: Col,
    Button,
    Popup,
    Cell,
    CellGroup,
    RadioGroup,
    Radio,
    CalendarDay,
    CalendarWeek,
    CalendarMonth
  },
  methods: {
    // 跳转到创建试驾页面
    createTestdrive () {
      this.$router.push({ path: '/testDriveCreate' })
    },
    // 切换门店的事件
    onstoreClick (e) {
      this.store = e
      this.storeShow = false
      this.getTestdriveList()
    },
    // 获取当前角色所属的门店,
    async getStoreList () {
      this.storeListS = this.$storage.get('userStore')
      this.store = this.$storage.get('userStore')[0]
      this.storeCode = this.$storage.get('userStore')[0]['code']
    },
    // 搜索icon点击跳转至搜索页面
    testdriveSearch () {
      this.$router.push({
        path: '/testdriveSearch'
      })
    },
    // 点击列表跳转至排程列表页面
    testdriveList () {
      let startTime
      let endTime
      if (this.timeRadio.current === 'day') {
        startTime = dayjs(this.initDay).format('YYYY-MM-DD')
        endTime = dayjs(this.initDay).format('YYYY-MM-DD')
      } else if (this.timeRadio.current === 'week') {
        startTime = dayjs(this.countDay.split('-')[0]).format('YYYY-MM-DD')
        endTime = dayjs(this.countDay.split('-')[1]).format('YYYY-MM-DD')
      } else {
        const YY = dayjs(this.countDay).year()
        let MM = dayjs(this.countDay).month() + 1
        if (MM < 10) { MM = '0' + MM }
        if (YY % 4 === 0 && MM === '02') {
          startTime = YY + '-' + MM + '-' + '01'
          endTime = YY + '-' + MM + '-' + '29'
        } else if (MM === '02') {
          startTime = YY + '-' + MM + '-' + '01'
          endTime = YY + '-' + MM + '-' + '28'
        } else if (MM === '01' || MM === '03' || MM === '05' || MM === '07' || MM === '08' || MM === '10' || MM === '12') {
          startTime = YY + '-' + MM + '-' + '01'
          endTime = YY + '-' + MM + '-' + '31'
        } else {
          startTime = YY + '-' + MM + '-' + '01'
          endTime = YY + '-' + MM + '-' + '30'
        }
      }
      this.$router.push({
        path: '/testDriveList',
        query: {
          'storeCode': this.store.code,
          'startTime': startTime,
          'endTime': endTime
        }
      })
    },
    // 获取排程
    async getTestdriveList () {
      /* Toast.loading({
        message: 'Loading...',
        forbidClick: true,
        loadingType: 'spinner',
        overlay: true
      }) */
      let startDate, endDate
      // console.log(this.timeRadio.current);
      // 对日期进行格式化 YYYY-MM-DD
      if (this.timeRadio.current === 'month') {
        const YY = dayjs(this.countDay).year()
        let MM = dayjs(this.countDay).month() + 1
        if (MM < 10) {
          MM = '0' + MM
        }
        if (YY % 4 === 0 && MM === '02') {
          startDate = YY + '-' + MM + '-' + '01'
          endDate = YY + '-' + MM + '-' + '29'
        } else if (MM === '02') {
          startDate = YY + '-' + MM + '-' + '01'
          endDate = YY + '-' + MM + '-' + '28'
        } else if (MM === '01' || MM === '03' || MM === '05' || MM === '07' || MM === '08' || MM === '10' || MM === '12') {
          startDate = YY + '-' + MM + '-' + '01'
          endDate = YY + '-' + MM + '-' + '31'
        } else {
          startDate = YY + '-' + MM + '-' + '01'
          endDate = YY + '-' + MM + '-' + '30'
        }
      } else {
        startDate = dayjs(this.initDay).format('YYYY-MM-DD')
        endDate
        if (this.countDay.split('-').length > 1) {
          endDate = dayjs(this.countDay.split('-')[1]).format('YYYY-MM-DD')
        } else {
          endDate = dayjs(this.initDay).format('YYYY-MM-DD')
        }
      }
      try {
        const res = await checkTime({
          storeCode: this.store.code,
          startDate: startDate,
          endDate: endDate,
          vehicleId: ''
        })
        Toast.clear()
        if (res.success) {
          // 处理数据，添加日历所需要的字段
          res.data.forEach((item, index) => {
            item['date'] = dayjs(item.appointmentDate).format('YYYY/MM/DD')
            item['bookstore'] = item.eosStoreCode
            item['time'] = item.appointmentTime
            item['title'] = `${item.appointmentTime}</br>${item.qbsAccountName == null ? item.qbsAccountPhone : item.qbsAccountName}`
            item['tel'] = item.qbsAccountPhone
            item['state'] = item.testDriveStatus
            item['id'] = (index + 1).toString()
            item.start = `${dayjs(item.appointmentDate).format('YYYY/MM/DD')} ${item.appointmentTime.split('-')[0]
              }:00`
            item.end = `${dayjs(item.appointmentDate).format('YYYY/MM/DD')} ${item.appointmentTime.split('-')[1]
              }:00`
            item['category'] = 'time'
            item['calendarId'] = (index + 1).toString()
          })
          this.schedules = res.data
        } else {
          Toast(res.msg)
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * @description: 切换日历状态
     * @param {*} e 当前日历状态
     * @return {*} 无
     */
    onRadioChange (e) {
      this.timeRadio.current = e
      this.dayCount('radioChange', 0)
      this.todayFn()

    },
    onRadioClick (e) {
      this.timeRadio.current = e.label
      this.timeRadio.currentShow = e.name
      if (e.label === 'week') {
        this.timeRadio.todayShow = `本${e.name}`
      } else if (e.label === 'month') {
        this.timeRadio.todayShow = `本${e.name}`
      } else {
        this.timeRadio.todayShow = `今天`
      }
      this.swiperDay = false
    },
    showSwiper () {
      this.swiperDay = true
    },
    /**
     * @description: 执行查询
     * @param {*} 动作类型, 操作数量
     * @return {*}
     */
    dayCount (type, count) {
      if (type !== 'today') {
        if (this.timeRadio.current === 'week') {
          let week = dayjs(this.initDay)
          if (type !== 'radioChange') {
            week = dayjs(this.initDay)[type](count, 'week')
          }
          // 用周一进行计算
          this.initDay = week.weekday(1).format('YYYY/MM/DD')
          // 给服务端用于请求 和 页面头部展示
          this.countDay = `${week.weekday(1).format('YYYY/MM/DD')}-${week.weekday(6).format('YYYY/MM/DD')}`
        } else if (this.timeRadio.current === 'month') {
          let month = dayjs(this.initDay)
          if (type !== 'radioChange') {
            month = dayjs(this.initDay)[type](count, 'month')
          }
          // 每月一日计算
          this.initDay = month.format('YYYY/MM/DD')
          // 月份用于展示
          this.countDay = month.format('YYYY/MM')
        } else {
          this.initDay = dayjs(this.initDay).format('YYYY/MM/DD')
          if (type !== 'radioChange') {
            this.initDay = dayjs(this.initDay)[type](count, 'day').format('YYYY/MM/DD')
          }
          this.countDay = this.initDay
        }
      } else {
        const today = dayjs()
        if (this.timeRadio.current === 'week') {
          // 用周一进行计算
          this.initDay = today.weekday(1).format('YYYY/MM/DD')
          // 给服务端用于请求 和 页面头部展示
          this.countDay = `${today.weekday(1).format('YYYY/MM/DD')}-${today.weekday(6).format('YYYY/MM/DD')}`
        } else if (this.timeRadio.current === 'month') {
          // 每月一日计算
          this.initDay = today.format('YYYY/MM/DD')
          // 月份用于展示
          this.countDay = today.format('YYYY/MM')
        } else {
          this.initDay = today.format('YYYY/MM/DD')
          this.countDay = this.initDay
        }
      }
      this.getTestdriveList()
    },
    todayFn () {
      this.dayCount('today', 0)
    },
    prevFn () {
      this.dayCount('subtract', 1)
    },
    nextFn () {
      this.dayCount('add', 1)
    },
    async init () {
      this.timeRadio.current = 'day'
      this.timeRadio.currentShow = '日'
      this.timeRadio.todayShow = '今日'
      await this.getStoreList()
      // 加载状态结束
      this.list = []
      this.loading = false
      // 获取当前时间
      // this.initDay = '2019/10/30'
      this.initDay = dayjs().format('YYYY/MM/DD')
      // 当前日期用于计算
      this.countDay = this.initDay
      this.getTestdriveList()
    }
  },
  mounted () {
    this.init()
  }
}
</script>
